module.exports = __webpack_public_path__ + "img/Indus.9f4bfcb1.png";